<template>
  <Container type="card-full">
    <div slot="header">
      <el-button  @click="addPsu" v-if="showButton == 0">新增</el-button>
      <el-button  @click="delPsu" v-if="showButton == 0">删除</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <div class="container">
      <vggrid ref="xGrid" class="vggrid" :list="list" tableheight="700" flexname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick"></vggrid>

      <el-form :model="form" ref="form" class="content ss-fl" v-if="psuform && showButton == 0">
        <el-row>
          <el-col :span="40">
            <el-form-item label="供应商" :label-width="formLabelWidth">
              <el-select v-model="form.psucomid" filterable :clearable="true"  @change="getAppendList">
                <el-option v-for="(item, index) in comList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.psuid">
          <el-form-item label="" :label-width="formLabelWidth">
            <upload-btn v-if="form.psuid"  @changed='setfile' text="上传"></upload-btn>
          </el-form-item>
          <el-table :data="appendList" class="eltable" border>
              <el-table-column label="序号" prop="appendseq" width="60"></el-table-column>
              <el-table-column label="附件名" prop="appendfilename" width="250"></el-table-column>
          </el-table>
        </el-row>
        <el-form-item label="" :label-width="formLabelWidth">
          <el-button type="primary" @click="savePsu">保存</el-button>
          <el-button type="danger" @click="delPsu">删除</el-button>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  import config from '../../assets/config'
  import uploadBtn from '../common/uploadBtn'
  export default {
    name: 'psuBatchForm',
    props: {
      cproject: Object
    },
    data () {
      return {
        list: [],
        comList:[],
        project: this.$route.params.form,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'comfullname', fieldtype: 'C', title: '供应商',calculExpr:'',addNewRowFlg: false},
          { field: 'username', fieldtype: 'C', title: '报名人',calculExpr:'',addNewRowFlg: false},
          { field: 'psutime', fieldtype: 'C', title: '报名时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']}
        ],
        psuform: false,
        form: {},
        appendList:[],
        appends: [],
        loading: true,
        formLabelWidth: '100px',
        showButton:Number(this.$route.params.form.projectstatus) === 10 ? 0 : 1
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getPsuList()
      this.getComList()
    },
    async mounted () {
      await this.init()
      await this.getPsuList()
      await this.getComList()
    },
    components: {vggrid,uploadBtn},
    computed: {
      uploadAddr() {
        return this.$store.getters.uploadAddr
      }
    },

    methods: {
      async init() {
        this.list = []
        this.comList = []
        this.project = this.cproject ||  this.$route.params.form
        this.form = {}
        this.appendList = []
        this.psuform = false
        this.showButton = Number(this.$route.params.form.projectstatus) === 10 ? 0 : 1
      },
      async getAppendList(comid) {
        this.appendList = await request({
          url: '/ywgl/append/getPageList',
          method: "get",
          params: {appendfromid: comid,appendfromtype: 4}
        })
      },
      async addPsu () {
        this.psuform = true
        this.form = {
          psuid: 0,
          psutype: '1',
          psuuserid: this.$store.getters.loginUser.userid,
          psuprojectid: this.project.projectid,
          psustatus: this.project.prsbmneedconfirm === '1'?'1':'2',
          psubmamt: this.project.projectbmamt,
          psubzjamt: this.project.projectbzjamt
        }
      },
      async getComList() {
        this.comList = await request({
          url: '/ywgl/com/getComList',
          method: "get",
          params: {}
        })
      },
      async delPsu () {
        if (this.project.projectstatus!=='10') {
          this.$message.error('项目公告已发布，不能修改删除报名信息！')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/jjgl/project/delPsu',
            method: "post",
            data: this.form
          })
          if (data.issuccess === 1) {
            this.getPsuList()
            this.$message.success('删除成功！')
          }
        })
      },
      async setfile  (path,filename) {
        if (this.project.projectstatus!=='10') {
          this.$message.error('项目公告已发布，不能修改删除供应商报名资质文件！')
          return
        }
        let append = {
          appendid: 0,
          appendfromid: this.form.psuid,
          appendfromtype: '4',
          appendtype: '100',
          appendseq: this.appendList.length+1,
          appendfilecode: '',
          appendfilename: filename,
          appendurl: path.replace(this.uploadAddr,'')
        }
        let data = await request({
          url: '/ywgl/append/addOrEdit',
          method: "post",
          data: append
        })
        if (data.issuccess===1) {
          await this.getAppendList()
          this.$message.success('报价文件上传成功')
        } else {
          this.$message.error('报价文件上传失败')
        }
      },
      async getAppendList() {
        console.log(this.form)
        this.appendList = await request({
          url: '/ywgl/append/getPageList',
          method: "get",
          params: {appendfromid: this.form.psuid,appendfromtype: 4}
        })
      },
      async savePsu () {
        if (this.project.projectstatus!=='10') {
          this.$message.error('项目公告已发布，不能新增/修改报名信息！')
          return
        }
        let data = await request({
          url: '/xmgl/project/savePsu',
          method: "post",
          data: this.form
        })
        if (data.issuccess===1) {
          await this.getPsuList()
          this.psuform = false
          this.$message.success('报名成功')
        } else {
          this.$message.error('报名失败')
        }

      },
      async cellClick (row) {
        this.form = row.row
        this.getAppendList()
        this.psuform = true
      },
      async getPsuList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPsuListByProjectId',
          params: {projectid: this.project.projectid}
        })
        this.list = {}
        this.list = res
        this.loading = false
      },
      close () {
        let returnForm = 'projectIndex'
        if (this.project.projecttype === '2') {
          returnForm = 'projectZjIndex'
        }
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: returnForm})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    .vggrid {
      border: 1px solid #d1dbe5;
      width: 400px;
      margin-right: 5px;
    }
    .eltable {
      margin-left: 50px;
      width: 800px;
      height: 250px;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
  }
  #menuReportDiv {
    height: 380px;
    overflow: auto;
  }
</style>
